import styled from "react-emotion"
import PropTypes from "prop-types"
import WithMarginAndPadding from "../utils/WithMarginAndPadding"

const Container = styled(WithMarginAndPadding)`
    // Basically, a container is a horizontal stacking (column-based) flex container
    // Compare against Section

    display: flex;
    flex-direction: row;
    align-items: flex-start; // Don't make things be as tall as the container

    width: ${props => props.width};
    ${props =>
        props.maxSize &&
        `
        flex-grow: ${props.maxSize};
    `}    
    ${props =>
        props.spaced &&
        `
        justify-content: space-between;
    `}
    ${props =>
        props.wrapItems &&
        `
        flex-wrap: wrap;
    `}
    ${props =>
        props.centered &&
        `
        align-items: center;
    `}
`

Container.propTypes = {
    ...WithMarginAndPadding.propTypes,
    maxSize: PropTypes.number,
    spaced: PropTypes.bool,
    wrapItems: PropTypes.bool,
}
Container.displayName = "Container"

export default Container



// WEBPACK FOOTER //
// ./src/ui/components/Container.js